import React from 'react';
import { SubHeader } from '../../../components/sub-header/SubHeader';
import { SubHeaderRails } from '../../../components/sub-header/SubHeaderRails';
import { LawFirmActionSlider } from './LawFirmActionSlider';
import { LawFirmInfos } from '../../lawFirm.types';

type Props = {
  isVisible: boolean;
  lawFirmInfos: LawFirmInfos;
};

export function LawFirmSubHeader({
  isVisible,
  lawFirmInfos: { name, lawOfficeIdGroup },
}: Props) {
  return (
    <SubHeader classNames="hide_on--mobile" id="law-firm-sub-header">
      <SubHeaderRails>
        <LawFirmActionSlider
          isVisible={isVisible}
          name={name}
          lawOfficeIdGroup={lawOfficeIdGroup}
        />
      </SubHeaderRails>
    </SubHeader>
  );
}
